var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 48,
    viewBox: "0 0 85 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48.0002C37.2548 48.0002 48 37.2551 48 24.0002C48 10.7454 37.2548 0.000244141 24 0.000244141C10.7452 0.000244141 0 10.7454 0 24.0002C0 37.2551 10.7452 48.0002 24 48.0002Z",
    fill: "#0D4E58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0001 48.0002C55.255 48.0002 66.0001 37.2551 66.0001 24.0002C66.0001 10.7454 55.255 0.000244141 42.0001 0.000244141C28.7453 0.000244141 18.0001 10.7454 18.0001 24.0002C18.0001 37.2551 28.7453 48.0002 42.0001 48.0002Z",
    fill: "#FF9A5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0406 48.0002C73.2955 48.0002 84.0406 37.2551 84.0406 24.0002C84.0406 10.7454 73.2955 0.000244141 60.0406 0.000244141C46.7858 0.000244141 36.0406 10.7454 36.0406 24.0002C36.0406 37.2551 46.7858 48.0002 60.0406 48.0002Z",
    fill: "#FFF966"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.461 25.5153C58.0635 25.5153 58.552 26.0037 58.552 26.6062V36.0138H61.5553V26.6062C61.5553 26.0037 62.0437 25.5153 62.6462 25.5153H72.0538V22.512H62.6462C62.0437 22.512 61.5553 22.0236 61.5553 21.4211V12.0138H58.552V21.4211C58.552 22.0236 58.0635 22.512 57.4611 22.512H48.0538V25.5153H57.461Z",
    fill: "#203B3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo-mini.10a32e8eaa8bf8993f239daf40273050.svg";
export { ForwardRef as ReactComponent };